module.exports = __webpack_public_path__ + "static/media/Icons-nav-notifications.f4c6217d.svg";